import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { getCategoryIcon, isExpandable, isExternal } from './config';

const CategoryCard = ({ category, isSelected, onClick }) => {
  const { product_category_id, name, title, description, type, icon_name } = category;
  const displayName = name || title || '';
  const expandable = isExpandable(category);
  const external   = isExternal(category);

  const handleClick   = () => onClick(category);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); }
  };

  return (
    <div
      className={`aptv2-category-card${isSelected ? ' aptv2-category-card--selected' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-expanded={expandable ? isSelected : undefined}
      aria-pressed={!expandable ? isSelected : undefined}
    >
      {/* Left selected indicator bar */}
      <div className="aptv2-category-indicator" aria-hidden="true" />

      {/* Icon */}
      <div
        className={`aptv2-category-icon${isSelected ? ' aptv2-category-icon--selected' : ''}`}
        aria-hidden="true"
      >
        {getCategoryIcon(icon_name, type)}
      </div>

      {/* Text content */}
      <div className="aptv2-category-content">
        <span className="aptv2-category-title">{displayName}</span>
        {description && (
          <span className="aptv2-category-desc">{description}</span>
        )}
      </div>

      {/* Right chevron */}
      <div
        className={`aptv2-category-chevron${isSelected && expandable ? ' aptv2-category-chevron--open' : ''}`}
        aria-hidden="true"
      >
        {external ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
          </svg>
        ) : (
          <RightOutlined />
        )}
      </div>
    </div>
  );
};

export default CategoryCard;
